(function() {
    angular
        .module("app")
        .controller("SupportController", SupportController)

    SupportController.$inject = [
        "$scope",
        "$rootScope",
        "$uibModal",
        "feedbackService",
        "userMessagingService"
    ]

    function SupportController(
        $scope,
        $rootScope,
        $uibModal,
        feedbackService,
        userMessagingService
    ){
        "use strict"

        $rootScope.title = "Support | WANCO"

        $scope.customerSupportFormData = {}

        $scope.openDevicesVideoModal = function() {
            $uibModal.open({
                templateUrl: "app/modals/iframe.view.html",
                controller: "IFrameController",
                size: "lg",
                resolve: {
                    frameData: function() {
                        return {
                            url: "https://www.youtube.com/embed/r3ux7TO0QHk",
                            height: 400,
                            "cookie": "device"
                        }
                    },
                    tutorialType: function() {
                        return "Device List"
                    }
                }
            }).result.catch(function(res) {
                if (!(res === "cancel" || res === "escape key press")) {
                    throw res
                }
            })
        }

        $scope.openDeviceDetailsVideoModal = function() {
            $uibModal.open({
                templateUrl: "app/modals/iframe.view.html",
                controller: "IFrameController",
                size: "lg",
                resolve: {
                    frameData: function() {
                        return {
                            url: "https://www.youtube.com/embed/FE12r2enh_8",
                            height: 400,
                            cookie: "deviceDetails"
                        }
                    },
                    tutorialType: function() {
                        return "Device Details Pages"
                    }
                }
            }).result.catch(function(res) {
                if (!(res === "cancel" || res === "escape key press")) {
                    throw res
                }
            })
        }

        $scope.submitSupportForm = function() {
            $scope.customerSupportFormSubmitted = true
            if ($scope.customerSupportForm.$valid) {
                $scope.customerSupportFormSubmitted = false

                feedbackService.submitFeedback(
                    angular.fromJson($scope.customerSupportFormData),
                    function() {
                        //Success
                        $scope.feedbackFormOpen = false
                        $scope.customerSupportFormData = {}
                        userMessagingService.success("Thank you for submitting your feedback.")
                    },
                    function(error) {
                        //Failure
                        userMessagingService.error(error)
                    }
                )
            }
        }
    }
})()
